import { Navigate, Route, Routes } from "react-router-dom";
import { AdminShell } from "@/components/layout/AdminShell";
import { PublicShell } from "@/components/layout/PublicShell";
import { ClientEditorPage } from "@/pages/ClientEditorPage";
import { ClientsPage } from "@/pages/ClientsPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { InvoiceDetailPage } from "@/pages/InvoiceDetailPage";
import { InvoiceEditorPage } from "@/pages/InvoiceEditorPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PublicInvoicePage } from "@/pages/PublicInvoicePage";
import { SettingsPage } from "@/pages/SettingsPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/app" replace />} />

      <Route path="/app" element={<AdminShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="invoices/new" element={<InvoiceEditorPage />} />
        <Route path="invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="invoices/:id/edit" element={<InvoiceEditorPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/new" element={<ClientEditorPage />} />
        <Route path="clients/:id" element={<ClientEditorPage />} />
        <Route path="clients/:id/edit" element={<ClientEditorPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      <Route element={<PublicShell />}>
        <Route path="/i/:token" element={<PublicInvoicePage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
